// Components
import GridMasonry from '../GridMasonry/GridMasonry';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

// Styles
import styles from './DashboardCardsSkeleton.module.css';
import itemListCardStyles from '../../molecules/ItemListCard/ItemListCard.module.css';

/**
 * Placeholder grid of dashboard cards, shown while the dashboard (re)loads
 * @returns {JSX.Element}
 */
function DashboardCardsSkeleton() {
  return (
    <GridMasonry>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => (
        <div key={index} className={itemListCardStyles['item-list-card']}>
          <div className={itemListCardStyles.header}>
            <Skeleton shape="rectangle" width="60%" height="20px" />
            {index % 2 === 0 && (
              <div className={itemListCardStyles.action}>
                <Skeleton shape="rectangle" width="24px" height="24px" />
              </div>
            )}
          </div>
          <div>
            {[1, 2, 3, 4].map((itemIndex) => (
              <div key={itemIndex} className={styles['dashboard-card-skeleton-row']}>
                <Skeleton shape="rectangle" width="120px" height="16px" />
                <Skeleton shape="rectangle" width={`${50 + (itemIndex * 5)}%`} height="16px" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </GridMasonry>
  );
}

export default DashboardCardsSkeleton;
